import { SafeAny } from '@models/common';
import localforage from 'localforage';

export enum EStorageKeys {
  TOKEN = 'token',
  CURRENCY = 'CURRENCY'
}

export const storageSet = (key: EStorageKeys, value: SafeAny) => {
  return localforage.setItem(key, value);
};

export const storageGet = <T = SafeAny>(key: EStorageKeys): Promise<T | null> => {
  return localforage.getItem<T>(key);
};

export const storageRemove = (key: EStorageKeys) => {
  return localforage.removeItem(key);
};

export const storageClear = () => {
  return localforage.clear();
};
